
import { i18nText } from '@/locales';

import { Component, Vue, Watch } from "vue-property-decorator";
import CalendarWithEvents from "@/UI/components/Calendar/VCalendar";

import { SalaryStore } from "@/store/modules/Salary";
import { StatusesStore } from "@/store/modules/Status";
import { PositionStore } from "@/store/modules/Position";
import { WorkersStore } from "@/store/modules/Workers";
import { IPosition } from "@/entity/position/position.types";
import { IStatus } from "@/entity/status/status.types";
import { ISalaryScheme } from "@/entity/salaryScheme/salaryScheme.types";
import { SalonsStore } from "@/store/modules/Salons";
import { ISalons } from "@/entity/salons/salons.types";
import { VisitsStore } from "@/store/modules/Visits";
import { IVisits, IVisitsListItem } from "@/entity/visits/visit.types";
import { DatePicker, Col, Row, Alert, notification } from "ant-design-vue";

import { End, Start } from "@/UI/pages/visits/Visits.vue";

import { RouterNameEnum } from "@/router/router.types";
import { getStudioId } from "@/UI/lib/state";
import { mixins } from "vue-class-component";
import { WorkersMix } from "@/UI/mixins/Store/WorkersMix";
import { showNotificationSimple } from "@/UI/lib/messages";
import { DateMix } from "@/UI/mixins/Calendar/DateMix";
import { VisitsGeneralMix } from "@/UI/mixins/Visits/VisitsGeneralMix";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { StaffSheduleMix } from "@/UI/mixins/Calendar/StaffSheduleMix";

import { StaffScheduleStore } from "@/store/modules/Staff/Schedule";
import { IStaffScheduleListItem } from "@/entity/staff/schedule.types";
import EDateTimePicker from "@/UI/components/EDateTimePicker/EDateTimePicker.vue";

import dayjs from "dayjs";
import { DateTime } from "ts-luxon";
import { parseDateFormatted, lxDateToSpecFormat, addPrefix, lxDateToTimeShort } from "@/UI/lib/parseSupport";
import { AsYouType } from "libphonenumber-js";
import { RecordDataForm } from "@/form/visits/New/Record";
import { MoveVisit } from "@/UI/pages/visitsNew/Lib/visitTypes";
import { IWorkersListItem } from "@/entity/workers/workers.types";
import { calendarEventT } from "@/UI/pages/visitsNew/Lib/visitTypes";
import {
  isTimeIntervalAvailable,
  moveVisitAction,
  genDate,
  parseVisitsCurrentData,
} from "@/UI/pages/visitsNew/Lib/support";

@Component({
  components: {
    BaseDataForm,
    "e-calendar": CalendarWithEvents,
    "a-col": Col,
    "a-row": Row,
    "a-date-picker": DatePicker,
    "a-alert": Alert,
    "e-datetimepicker": EDateTimePicker,
  },
  methods: {
    getStudioId,
    dayjs,
    addPrefix,
  },
})
export default class VisitsNew extends mixins(
  WorkersMix,
  DateMix,
  SimpleProxyForm,
  StaffSheduleMix,
  VisitsGeneralMix,
) {
  moveModal = false;
  moveData: any = null;

  Loaded = false;
  calendarKey = 0;

  date: string = "";
  value: "";
  picker: any;

  focus!: string;
  events: calendarEventT[] | any;
  colors: any[];

  names: string[];
  // categories: string[];
  categoriesCosmetologists: any[] = [];
  //categoriesCosmetologists_id: any[];
  dragTime: any | null;
  dragEvent: calendarEventT | null | any;
  lastEvent: calendarEventT | null | any;
  createEvent: any | null;
  createStart: any | null;
  extendOriginal: null;
  start: Start | null = null;
  end: End | null = null;
  ready: boolean;
  visible: boolean;
  select_salon_id: number;
  select_salon_name: string | undefined;

  isAlreadyUpdating: boolean = false;

  data: any | null = null;

  startDate = Number(new Date());
  allowUpdate = true;

  currentDate = dayjs().format("DD.MM.YYYY");
  firstTime = "08:00:00";
  endTime = "22:00:00";
  lastEventName = "";
  dragProcess = false;

  vData = new RecordDataForm();
  storeVisit = false;

  startMoveDt: DateTime | any;
  endMoveDt: DateTime | any;
  updateTimer: any;

  constructor() {
    super();

    this.picker = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);

    this.value = "";
    this.ready = false;

    this.focus = "";
    this.categoriesCosmetologists = [];

    this.events = [];
    //this.type = "category";
    this.colors = ["#FFE46E", "#FFD5FF", "#5FFFF2", "#A9F7FF", "#69C0FF"];
    this.names = ["Meeting", "Holiday", "PTO", "Travel", "Event", "Birthday", "Conference", "Party"];
    this.visible = false;
    this.select_salon_id = 0;
    this.select_salon_name = "";
    this.startDate = Number(new Date());
  }

  async eventLink(event: any): Promise<void> {
    console.log('eventLink')
    this.lastEventName = "dblClick";
    clearTimeout(this.updateTimer);

    console.log('eventLink event.end', event.end)
    event.visitData.visit_dt_end = event.end;
    console.log('eventLink event.start', event.start)
    event.visitData.visit_dt_start = event.start;

    console.log('eventLink Vue.router', RouterNameEnum.VisitsNewStatusFm)
    const params = {
        Studio: getStudioId(this),
        Worker: event["visitData"]["staff"]["id"],
        mode: "status",
        id: event["visitData"]["id"],
        params: JSON.stringify(event),
        event: JSON.stringify(event["visitData"]),
        isNew: "0",
      }
    console.log('eventLink Vue.router params', params)
    await Vue.router.push({
      name: RouterNameEnum.VisitsNewStatusFm,
      params: {
        Studio: getStudioId(this),
        Worker: event["visitData"]["staff"]["id"],
        mode: "status",
        id: event["visitData"]["id"],
        params: JSON.stringify(event),
        event: JSON.stringify(event["visitData"]),
        isNew: "0",
      },
    });
  }

  getMovedDate(event: MoveVisit): { from: IWorkersListItem[] | undefined; to: IWorkersListItem[] | undefined } {
    return {
      from: this.getWorkerById(event.category.fromCategory),
      to: this.getWorkerById(event.category.toCategory),
    };
  }

  MoveRecordStart(event: any): void {
    console.log('MoveRecordStart')
    this.lastEventName = "moveRecord";
    event.preventDefault();
  }

  MoveRecord(event: MoveVisit): void {
    console.log('MoveRecord')
    if (this.isAlreadyUpdating) {
      return;
    }

    this.moveData = { ...event };
    if (event.category.fromCategory !== event.category.toCategory) {
      this.lastEventName = "moveRecord";
      this.moveModal = true;
    }
  }

  async moveOk(): Promise<void> {
    try {
      const events = this.events.slice();
      let id = this.lastEvent.id//(this.moveData as MoveVisit).event.id;
      if (!id) {
        id = this.lastEvent.id;
      }
      await moveVisitAction(id, this.moveData as MoveVisit, events, VisitsStore);

    } catch (e) {
      showNotificationSimple(i18nText("Ошибка при перемещении визита"), e, 10);
    } finally {
      await VisitsStore.clearData();
      await this.getData();
      this.moveModal = false;
    }
  }

  async moveCancel(): Promise<void> {
    //await this.ParseEventsBreak();
    //await this.ParseNonWorking();
    this.moveModal = false;
  }

  async afterMoveModalClose(): Promise<void> {
    await this.ParseEvents();
  }

  renderPhone(value: string): string {
    return new AsYouType().input('+' + String(value).replace(/\D/g, '')).replace(/^\+/, '');
  }

  getEventNWHTML(event: any, timed: any, mode: number): string {
    let message = "";
    if (mode === 0) {
      message = i18nText("нерабочее время");
    }
    if (mode === 1) {
      message = i18nText("перерыв");
    }

    let st = event["start"],
      ed = event["end"];

    if (typeof event === "string") {
      st = st.replace(" ", ",");
      ed = ed.replace(" ", ",");
      const start = parseDateFormatted(st),
        end = parseDateFormatted(ed);
      return `<div> <p>${start?.hours}-${end?.hours}</p>
                    <p style="margin-left: 10px"><b>${message}</b></p>
                    </div>`;
    } else {
      return `<div> </p>
                    <p style="margin-left: 10px"><b>${message}</b></p>
                    </div>`;
    }
  }

  parseEvent(event: any): any {
    let st = event["start"],
      ed = event["end"];
    st = st.replace(" ", ",");
    ed = ed.replace(" ", ",");
    const start = parseDateFormatted(st),
      end = parseDateFormatted(ed);
    return {
      start: start,
      end: end,
    };
  }

  intervalStyle(): any {
    return {
      borderTop: "1.5px dashed " + "#c4c5f2",
      borderRight: "1.5px dashed " + "#c4c5f2",
    };
  }

  intervalFormat(interval: any): any {
    return interval.time;
  }

  @Watch("$route", { immediate: true })
  async onRouteChange(): Promise<void> {
    console.log('onRouteChange')
    if (this.allowUpdate) {
      await this.getData();
      this.allowUpdate = false;
    }
  }

  @Watch("$store.state.salon_id", { immediate: false })
  async onStudioChange(): Promise<void> {
    showNotificationSimple(i18nText("Внимание"), i18nText("Подготовка журнала записи"), 1);
    try {
      await this.getData();
    } catch (e) {
      showNotificationSimple(i18nText("Ошибка получения данных"), i18nText("Журнал записи готов!"), 10);
    } finally {
      this.calendarKey += 1;
      showNotificationSimple(i18nText("Внимание"), i18nText("Журнал записи готов!"), 10);
    }
  }

  async changeDateCalendar(value: any): Promise<void> {
    if (value) {
      await Vue.router.push({
        name: this.$routeRules.VisitsNewDate,
        params: {
          Date: String(new Date(value["_d"]).getTime()),
          Studio: getStudioId(this),
        },
      });
      await this.getData();
    }
  }

  async getCalendarCategories(): Promise<void> {
    this.categoriesCosmetologists = [];
  }

  getCurrentTime(): any {
    return (this.$refs["calendar"] as any)
      ? (this.$refs["calendar"] as any).times.now.hour * 60 + (this.$refs["calendar"] as any).times.now.minute
      : 0;
  }

  scrollToTime(): void {
    const time = this.getCurrentTime();
    const first = Math.max(0, time - (time % 30) - 30);

    (this.$refs["calendar"] as any).scrollToTime(first);
  }

  async CreateRecord(nativeEvent: any): Promise<void> {
    console.log('CreateRecord')
    console.log('CreateRecord', nativeEvent)
    console.log('create record', nativeEvent.category)
      console.log('check', nativeEvent.category.category === null)
    if (nativeEvent.category.position_id === 1) {
      console.log('inside')
      notification.info({
        message: i18nText("К сотруднику нельзя записаться"),
        description: i18nText('Проверьте должность сотрудника: {name} — {position}', {name: nativeEvent.category.fio, position: nativeEvent.category.position_name}),
        duration: 2
      });
      return
    }
    /*if (this.isAlreadyUpdating) {
      return;
    }*/
    clearTimeout(this.updateTimer);
    console.log('CreateRecord 2')
    if (!this.dragProcess) {
      console.log('!this.dragProcess')
      console.log('getStudioId(this)', nativeEvent)
      await Vue.router.push({
        name: RouterNameEnum.VisitsNewRecord,
        params: {
          Studio: getStudioId(this),
          Worker: nativeEvent["category"]["id"],
          params: JSON.stringify(nativeEvent),
          mode: "create",
        },
      });
    } else {
      console.log('this.dragProcess - false')
      this.dragProcess = false;
    }
  }

  async ParseNonWorking(): Promise<void> {
    const dta = this.getCalendarDate().formatted;
    const break_date = new Date(dta["year"], dta["month"], dta["day"]);
    this.events = this.events.filter((item: Record<any, any>) => {
      return item.mode !== 'non-working'
    });

    this.workers?.data.map(async (worker: any) => {
      if (worker["schedule"][0]["work_start"] !== this.firstTime) {
        this.events.push({
          id: worker["id"],
          mode: "non-working",
          start: genDate(break_date, this.firstTime),
          end: genDate(break_date, worker["schedule"][0]["work_start"]),

          color: "#939393",
          timed: true,
          category: worker["name"],
        });
      }

      if (worker["schedule"][0]["work_finish"] !== this.endTime) {
        this.events.push({
          id: worker["id"],
          //visitData: visit,
          mode: "non-working",
          start: new Date(
            break_date.toDateString() + " " + String(worker["schedule"][0]["work_finish"]),
          ).getTime(),
          end: new Date(break_date.toDateString() + " " + String(this.endTime)).getTime(),
          color: "#939393",
          timed: true,
          category: worker["name"],
        });
      }
    });
  }

  async ParseEvents(): Promise<void> {
    //let events: any[] = [];
    //this.events = [];

    this.events = this.events.filter((item: Record<any, any>) => {
      return item.mode !== 'visit'
    });

    if (this.visits?.data && this.visits.data.length > 0) {
      this.visits?.data?.map(async (visit: IVisitsListItem) => {
        const stt = parseDateFormatted(visit.visit_dt.replace(" ", ",")),
          ett = parseDateFormatted(visit.visit_dt_end.replace(" ", ","));

        this.events.push({
          id: visit["id"],
          visitData: visit,
          mode: "visit",
          start: dayjs(visit.visit_dt).utc(true).format("YYYY-MM-DD HH:mm"),
          end: dayjs(visit.visit_dt_end).utc(true).format("YYYY-MM-DD HH:mm"),
          name: i18nText("Визит"),
          color: Number(visit.status_id) === 5 ? "#939393" : "#55d6a7",
          timed: true,
          category: visit["staff"]["name"],
          isBreackOut: !visit.client_id,

          check: {
            start: DateTime.local(
              Number(stt?.year),
              Number(stt?.month),
              Number(stt?.day),
              Number(stt?.hours),
              Number(stt?.minutes),
            ),
            end: DateTime.local(
              Number(ett?.year),
              Number(ett?.month),
              Number(ett?.day),
              Number(ett?.hours),
              Number(ett?.minutes),
            ),
          },
          moved: {
            start: null,
            end: null,
          },
        });
      });
    }
  }

  async ParseEventsBreak(): Promise<void> {
    const dta = this.getCalendarDate().formatted;
    this.events = this.events.filter((item: Record<any, any>) => {
      return item.mode !== 'break'
    });
    WorkersStore.workers?.data?.map(async (worker: any) => {
      await StaffScheduleStore.fetchAll({
        filter: {
          staff_id: worker["id"],
          day: dta.day,
          month: dta.month + 1,
          year: dta.year,
        },
      });
      StaffScheduleStore.items?.map(async (shedule: IStaffScheduleListItem) => {
        if (shedule["break_start"]) {
          const break_date = new Date(dta["year"], dta["month"], dta["day"]),
            start = genDate(break_date, shedule["break_start"]),
            end = genDate(break_date, shedule["break_finish"]);
          const check = this.events.find((event: any) => event.break_id === worker["id"]);
          if (!check) {
            this.events.push({
              id: worker["id"],
              break_id: worker["id"],
              mode: "break",
              color: "#93919c",
              start: start,
              end: end,
              category: worker["name"],
              timed: true,
            });
          }
        }
      });
    });
  }

  getRecordDate(): any {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    return {
      prev: function (mode: number) {
        if (mode === 0) {
          const date = new Date();
          return date.setDate(date.getDate() - 1);
        }
        if (mode === 1) {
          const date = new Date(Number(that.$router.currentRoute.params["Date"]));
          return date.setDate(date.getDate() - 1);
        }
      },
      next: function (mode: number) {
        if (mode === 0) {
          const date = new Date();
          return date.setDate(date.getDate() + 1);
        }
        if (mode === 1) {
          const date = new Date(Number(that.$router.currentRoute.params["Date"]));
          return date.setDate(date.getDate() + 1);
        }
      },
    };
  }

  async navigateCalendar(mode: number): Promise<void> {
    console.log('navigateCalendar')
    this.allowUpdate = true;
    this.formReady = false;

    if (mode === 0) {
      await Vue.router.push({
        name: this.$routeRules.VisitsNewDate,
        params: {
          Date: this.getRecordDate().prev(this.getCalendarMode()),
          Studio: getStudioId(this),
        },
      });
    }
    if (mode === 1) {
      await Vue.router.push({
        name: this.$routeRules.VisitsNewDate,
        params: {
          Date: this.getRecordDate().next(this.getCalendarMode()),
          Studio: getStudioId(this),
        },
      });
    }
    this.currentDate = this.getCalendarDate().current;
  }

  async showEvent({ nativeEvent }: { nativeEvent: any; event: any }): Promise<void> {
    console.log('showEvent')
    nativeEvent.stopPropagation();
    if (!this.dragProcess) {
      console.log('!this.dragProcess', !this.dragProcess)
    } else {
      this.dragProcess = false;
    }
  }

  startDrag({ event, timed }: { event: calendarEventT; timed: any }) {
    console.log('startDrag')
    if (this.isAlreadyUpdating) {
      return;
    }
    if (event && timed && event.mode === "visit" && Number(event.visitData.status_id) !== 5) {
    console.log('startDrag visit')
      this.lastEventName = "startDrag";
      this.dragEvent = event;
      this.dragTime = null;
      this.extendOriginal = null;
    }
  }

  startTime(e: any): void {
    console.log('startTime')
    if (this.isAlreadyUpdating) {
      return;
    }

    if (this.dragEvent && this.dragTime === null) {
      const startEvent = parseDateFormatted(this.dragEvent.start.replace(" ", ","));

      const MouseEventDate = DateTime.local(
        Number(e.year),
        Number(e.month),
        Number(e.day),
        Number(e.hour),
        Number(e.minute),
      );

      const EventDragStart = DateTime.local(
        Number(startEvent?.year),
        Number(startEvent?.month),
        Number(startEvent?.day),
        Number(startEvent?.hours),
        Number(startEvent?.minutes),
      );
      this.dragTime = MouseEventDate.toMillis() - EventDragStart.toMillis();
    } else {
      console.log("Добавить обработку ---");
    }
    this.lastEventName = "startTime";
  }

  async extendBottom(event: any): Promise<void> {
    this.createEvent = event;
    this.createStart = event.start;
    this.extendOriginal = event.end;
  }

  async mouseMove(e: any): Promise<void> {
    console.log('mouseMove')
    try {
      if (this.isAlreadyUpdating) {
        return;
      }
      if (this.dragEvent && this.dragTime !== null) {

        this.dragProcess = true;

        let start = this.dragEvent.start,
          end = this.dragEvent.end;

        start = start.replace(" ", ",");
        end = end.replace(" ", ",");

        const pDate = parseDateFormatted(start),
          pDateEnd = parseDateFormatted(end);
        const startDt = DateTime.local(
          Number(pDate?.year),
          Number(pDate?.month),
          Number(pDate?.day),
          Number(pDate?.hours),
          Number(pDate?.minutes),
        ),
          endDt = DateTime.local(
            Number(pDateEnd?.year),
            Number(pDateEnd?.month),
            Number(pDateEnd?.day),
            Number(pDateEnd?.hours),
            Number(pDateEnd?.minutes),
          );

        const eventDate = DateTime.local(
          Number(e.year),
          Number(e.month),
          Number(e.day),
          Number(e.hour),
          Number(e.minute),
        );

        const newStartTime = eventDate.toMillis() - this.dragTime;
        const dd = endDt.diff(startDt, ["hours", "minutes"]).toObject();

        const newSD = DateTime.fromMillis(this.roundTime(newStartTime));

        let newED = newSD;
        newED = newED.plus(dd);

        this.startMoveDt = newSD;
        this.endMoveDt = newED;

        this.dragEvent.start = lxDateToSpecFormat(newSD);
        this.dragEvent.end = lxDateToSpecFormat(newED);

        let start_date_time_start: string = lxDateToTimeShort(newSD);
        let start_date_time_end: string = lxDateToTimeShort(newED);

        const visitData = this.dragEvent.visitData;

        if (visitData) {
          await this.vData.parseVisitData(visitData);

          this.vData.visit_date_time_start = start_date_time_start;
          this.vData.visit_date_time_end = start_date_time_end;

          const event = this.events.find((event: any) => event.id === this.visit?.id);
          if (event) {
            event.moved.start = newSD;
            event.moved.end = newED;
          }

          this.startMoveDt = newSD;
          this.endMoveDt = newED;
        }
      } else if (this.createEvent && this.createStart !== null) {
      }
    } catch (e) {
      console.clear();
      console.error(e);
    }
  }

  checkIsUpdating(): boolean {
    if (this.isAlreadyUpdating) {
      console.log('checkIsUpdating')
      notification.info({
        message: i18nText("Данные обновляются"),
        description: i18nText("Пожалуйста, попробуйте позднее"),
        duration: 2
      });
    }

    return this.isAlreadyUpdating;
  }

  updateDelay(): void {
    if (this.vData.id !== 0) {
      const check = isTimeIntervalAvailable(this.events, {
        vData: this.vData,
        time: { start: this.startMoveDt, end: this.endMoveDt },
      });

      if (!check) {
        this.isAlreadyUpdating = true;
        this.$store.dispatch("visits/updateNew", this.vData).then(async (response) => {
          this.storeVisit = false;
          if (response["status"]) {

            const event = this.events.filter((event: any) => event.id === this.vData.id);
            if (event) {
              await this.fetchVisits();
              const events = this.events.filter((event: any) => event.id !== this.vData.id);
              event[0].visitData = { ...this.vData };
              events.push(event[0]);
              this.events = Array.from(events);

              showNotificationSimple(i18nText("Успешно"), response.response, 5);
            }

          } else {
            await this.ParseEvents();
            showNotificationSimple(i18nText("Ошибка обновления данных визита - "), response.response, 10);
          }
        }).finally(() => {
          this.isAlreadyUpdating = false;
        });
      } else {
        this.ParseEvents();
        this.vData = new RecordDataForm();
        showNotificationSimple(i18nText("Ошибка"), i18nText("Время для визита недоступно"), 10);
      }
    }
  }

  @Watch("lastEventName")
  hDragEvent(eventType: string): void {
    console.log('hDragEvent 23232', eventType);
    try {
      if (eventType === "endDrag" && !this.moveModal) {

        if (this.checkIsUpdating()) {
          return;
        }

        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(this.updateDelay, 500);

      }
    } catch (e) {
      console.clear();
      console.error(e);
    }
  }

  async endDrag(): Promise<void> {
    console.log('endDrag')

    this.dragTime = null;
    this.lastEvent = { ...this.dragEvent };
    this.lastEventName = "endDrag";
    this.dragEvent = null;
    this.createEvent = null;
    this.createStart = null;
    this.extendOriginal = null;
  }

  async cancelDrag(): Promise<void> {
    console.log('cancelDrag')
    this.createEvent = null;
    this.createStart = null;
    this.dragTime = null;
    this.dragEvent = null;
    if (!this.moveModal) {
      await this.ParseEvents();
    }
  }

  roundTime(time: any, down = true): number {
    const roundTo = 5; // minutes
    const roundDownTime = roundTo * 60 * 1000;

    return down ? time - (time % roundDownTime) : time + (roundDownTime - (time % roundDownTime));
  }

  getEventColor(event: any): any {
    const rgb = parseInt(event.color.substring(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    let isMatch = false;
    if (event && this.dragEvent) {
      isMatch = event.id === this.dragEvent.id;
    }

    return isMatch
      ? `rgba(${r}, ${g}, ${b}, 0.7)`
      : event.color;
  }

  get positions(): IPosition[] {
    return PositionStore.position;
  }

  get statuses(): IStatus[] {
    return StatusesStore.status;
  }

  get salary(): ISalaryScheme[] {
    return SalaryStore.salary;
  }

  get salons(): ISalons | null {
    return SalonsStore.salons;
  }

  get visits(): IVisits | null {
    return VisitsStore.visits;
  }

  get visit(): IVisitsListItem | null {
    return VisitsStore.visit;
  }

  async fetchVisits(): Promise<void> {
    console.log('fetchVisits')
    if (this.getCalendarMode() === 0) {

      this.startDate = Number(new Date());
      await parseVisitsCurrentData(null, getStudioId(this), VisitsStore);
    } else if (this.getCalendarMode() === 1) {
      this.startDate = Number(new Date(Number(this.$router.currentRoute.params["Date"])));
      await parseVisitsCurrentData(this.$router.currentRoute.params["Date"], getStudioId(this), VisitsStore);
    }
  }

  async getData(): Promise<void> {
    try {
      let currentDate = new Date();

      if (this.getCalendarMode() === 1) {
        currentDate = new Date(Number(this.$router.currentRoute.params["Date"]));
      }

      const dateQ = dayjs(currentDate).format("DD.MM.YYYY hh:mm:ss");

      await WorkersStore.fetchAll({
        filter: {
          salon_id: getStudioId(this),
          schedule_from: dateQ,
          schedule_to: dateQ,
        },
      });

      await this.fetchVisits();
      await this.getCalendarCategories();
      await this.ParseEvents();
      await this.ParseEventsBreak();
      await this.ParseNonWorking();

      await this.getRecordDate();

      this.currentDate = this.getCalendarDate().current;
    } catch (e) {
      console.error(e)
    } finally {
      this.Loaded = true;
      this.formReady = true;
    }
  }

  async created(): Promise<void> {
    this.Loaded = false;
    this.formReady = false;

    console.log('++++++++++++++++++++1676377640++++++++++++++++++++++++'); console.log('this : ' + (typeof this)); console.log(this); console.log('--------------------1676377640------------------------');
  }

  async mounted(): Promise<void> {
    try {
      this.Loaded = false;
      this.formReady = false;
      await this.getData();
    } catch (e) {
      console.error(e)
    }
  }
}

export type Event = {
  name: string;
  start: string;
  end: string;
  color: string;
};
